import getApiClient from '@/plugins/api-client'

export default {
    loadEvents() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('/events/short_list', {
            params: {
                'end[before]': new Date(),
                itemsPerPage: 10,
                page: self.page
            }
        })
            .then(result => {
                self.events.push(...result.data['hydra:member'])
                self.totalEvents = result.data['hydra:totalItems']
            })
            .catch(error => {
                console.log(error)
            })
    },

    isEventComplete(event) {
        return event.jobs.filter(job => {
            return job.status === 1
        }).length
    },

    loadEventsNextPage() {
        this.page++
        this.loadEvents()
    },

    cloneEvent(event) {
        const self = this,
          api = getApiClient(self.$store)

        api.post(`/events/${event.id}/clone`, {})
          .then(response => {
              const newEventId = response.data.id
              this.$router.push({name: 'ContractorCloneEventForm', params: {id: newEventId}})
          })
          .catch(() => {
              self.showCloneErrorMessage = true
          })
    },
}
